// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1__bcd15a7a59f6254ea664","cls2":"ToolsMenu-cls2___696a44d97e6413f14e3 ToolsMenu-cls1__bcd15a7a59f6254ea664"};